export default __webpack_public_path__ + "static/media/cookie-1.39da6470.png";